var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 35,
    viewBox: "0 0 28 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2327 11.6667H21.5731V8.33292C21.5731 3.66625 17.9229 0 13.2752 0C8.62896 0 4.97729 3.66625 4.97729 8.33292V11.6667H3.32062C2.43979 11.671 1.59396 12.024 0.972708 12.6481C0.35 13.2723 0.00145833 14.1196 0 15.0004V31.6663C0.00145833 32.5471 0.35 33.3929 0.972708 34.0171C1.59396 34.6413 2.43833 34.9956 3.31917 35H23.2312C24.1121 34.9956 24.9565 34.6413 25.5777 34.0171C26.2004 33.3929 26.549 32.5471 26.5504 31.6663V15.0004C26.549 14.1196 26.2004 13.2738 25.5777 12.6496C24.9565 12.0254 24.1121 11.671 23.2312 11.6667H23.2327ZM13.2752 26.6671C12.3944 26.6627 11.55 26.3083 10.9287 25.6842C10.3075 25.06 9.95896 24.2142 9.9575 23.3333C9.95896 22.4525 10.3075 21.6067 10.9287 20.9825C11.55 20.3583 12.3944 20.004 13.2752 19.9996C14.156 20.004 15.0019 20.3569 15.6231 20.981C16.2458 21.6052 16.5944 22.4525 16.5958 23.3333C16.5944 24.2142 16.2458 25.06 15.6231 25.6842C15.0019 26.3083 14.1575 26.6627 13.2767 26.6671H13.2752ZM18.4202 11.6667H8.13167V8.33292C8.13167 5.49938 10.4548 3.16604 13.2752 3.16604C16.0971 3.16604 18.4202 5.49938 18.4202 8.33292V11.6667Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.a7aeda6a.svg";
export { ForwardRef as ReactComponent };